import moment from 'moment';
import { isEmpty } from '@helpers/utils/utils.js';

export const formatDate = (date, patten = 'DD/MM/YYYY') => {
  return date ? moment(date, patten).local().format() : null;
};

export const formatDateByPattern = (date, patten = 'DD/MM/YYYY') => {
  return date ? moment(date).format(patten) : null;
};

export const formatAnyDate = (date) => {
  return date ? moment(date).format('DD/MM/YYYY') : null;
};

export const formatCurrentDate = () => {
  return moment().format('DD/MM/YYYY');
};

export const formatDateAndHour = (date) => {
  return date ? moment(date).format('DD/MM/YYYY HH:mm') : null;
};

export const formatDateHasTime = (date) => {
  return date ? moment(date).format('DD/MM/YYYY HH:mm:ss') : null;
};

export const formatDateHHmm = (date) => {
  return date ? moment(date).format('DD/MM/YYYY HH:mm') : null;
};

export const formatDateUTC = (date) => {
  return date ? moment(date).utc() : null;
};

export const formatLocalDate = (date) => {
  return date ? moment(date).format('YYYY-MM-DD') : null;
};

export const formatDateUTCToLocalTime = (date) => {
  return date ? moment.utc(date).local().format() : null;
};

export const formatDateToMilliseconds = (date) => {
  return date ? date?.valueOf() : null;
};

export const changeStringDate = (stringDate) => {
  if (stringDate === 'updatedDate') {
    return stringDate.replace('updatedDate', 'updated_at');
  }
  return stringDate.replace(/([A-Z])/g, '_$1').toLowerCase();
};

export const checkExpiredDate = (date) => {
  const futureDate = new Date('2222/12/31');
  if (new Date(date) >= futureDate) return '';
  return formatAnyDate(date);
};

export const changeFormatDate = (date) => {
  if (!date || isEmpty(date)) return null;
  const parts = date.split('/');
  const day = parseInt(parts[0], 10);
  const month = parseInt(parts[1], 10) - 1;
  const year = parseInt(parts[2], 10);
  return new Date(year, month, day);
};

export const formatDateByOptions = (date, { day, month, year }) => {
  if (day) date.setDate(date.getDate() + day);
  if (month) date.setMonth(date.getMonth() + month);
  if (year) date.setFullYear(date.getFullYear() + year);
  date.setHours(0, 0, 0, 0);
  return formatAnyDate(date);
};

export const formatDateAndHourWithUTC = (date) => {
  return date ? moment(date).format('DD/MM/YYYY HH:mm') : null;
};

export const formatDateAndHourSecondWithUTC = (date) => {
  return date ? moment(date).utc().format('DD/MM/YYYY HH:mm:ss') : null;
};

export const formatDateToDayMonth = (date) => {
  return date ? moment(date).utc().format('DD/MM') : null;
};

export const formatDateWithCondition = (date, format, type, value) => {
  return date ? moment(date).add(value, type).format(format) : null;
};

export const getFirstDayOfCurrentMonth = () => {
  const date = new Date();
  return new Date(date.getFullYear(), date.getMonth(), 1);
};

export const getLastDayOfCurrentMonth = () => {
  const date = new Date();
  return new Date(date.getFullYear(), date.getMonth() + 1, 0);
};

export const convertDateWithZeroTime = (date) => {
  return moment(date).set({
    hour: 0,
    minute: 0,
    second: 0,
    millisecond: 0,
  });
};

export const convertDateWithZeroTimeAdd50Years = (date) => {
  return moment(date)
    .set({
      hour: 0,
      minute: 0,
      second: 0,
      millisecond: 0,
    })
    .add(-50, 'years');
};

export const formatDateHHmmGMT7 = (date) => {
  return date ? moment.utc(date).utcOffset(7).format('DD/MM/YYYY HH:mm') : null;
};

export const getDateMinus = (date, dateMinus) => {
  const currentDate = new Date();
  const result = new Date();
  result.setDate(currentDate.getDate() - dateMinus);

  return result;
};

export const getQuarterStartDate = () => {
  const now = moment();
  const quarterStartMonth = Math.floor(now.month() / 3) * 3; // Start month of the quarter
  return moment().month(quarterStartMonth).startOf('month');
};

export const getQuarterEndDate = () => {
  const now = moment();
  const quarterStartMonth = Math.floor(now.month() / 3) * 3; // Start month of the quarter
  const quarterEndMonth = quarterStartMonth + 2; // End month of the quarter
  return moment().month(quarterEndMonth).endOf('month');
};

export const formatEpochToTime = (epochSeconds) => {
  if (!epochSeconds) return null;

  const hours = Math.floor(epochSeconds / 3600);
  const minutes = Math.floor((epochSeconds % 3600) / 60);
  const seconds = epochSeconds % 60;

  return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(
    2,
    '0',
  )}:${String(seconds).padStart(2, '0')}`;
};

export const generatePreviousMonths = (
  monthsCount = 3,
  fromDate = new Date(),
) => {
  const dateItems = [];
  const currentDate = new Date();
  const currentMonthString = `${String(currentDate.getMonth() + 1).padStart(
    2,
    '0',
  )}-${currentDate.getFullYear()}`;

  for (let i = 0; i < monthsCount; i++) {
    // Create a new date object for each iteration
    const date = new Date(fromDate);

    // Subtract i months from the starting date
    date.setMonth(date.getMonth() - i);

    // Format as MM-YYYY
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    const dateString = `${month}-${year}`;

    dateItems.push({
      dateTypeId: dateString,
      dateTypeName: dateString,
      isCurrentMonth: dateString === currentMonthString,
      sortOrder: i, // 0 = latest, 1 = previous, etc.
    });
  }

  // Sort by latest month first (already sorted, but explicit for clarity)
  return dateItems.sort((a, b) => a.sortOrder - b.sortOrder);
};

export const isDateGreaterOrEqual = (day, month, year) => {
  const today = new Date();
  // Reset time to midnight for accurate date comparison
  today.setHours(0, 0, 0, 0);

  const targetDate = new Date(year, month - 1, day);
  targetDate.setHours(0, 0, 0, 0);

  return today >= targetDate;
};
